//import store from '../../store'

export default class AdminRequestManagementNavigation {
    constructor() {
        ////console.log($store.state.settings.VacationBudgeCount);
    }
    VacationManagement() {
        //var budge = store.getters.VacationBudgeCount;
        ////console.log(budge);
        return {
            id: "nav-vacation-management",
            title: "nav-vacation-management",
            icon: "",
            to: "admin-vacation-management",
            subItems: [],
            //budge: budge,
            order: 1,
        }
    }
    MissionManagement() {
        //var budge = store.getters.MissionBudgeCount;
        ////console.log(budge);
        return {
            id: "nav-mission-management",
            title: "nav-mission-management",
            icon: "",
            to: "admin-mission-management",
            subItems: [],
            //budge: budge,
            order: 2,
        }
    }
    IOManagement() {
        //var budge = store.getters.IOBudgeCount;
        ////console.log(budge);
        return {
            id: "nav-io-management",
            title: "nav-io-management",
            icon: "",
            to: "admin-io-management",
            subItems: [],
            //budge: budge,
            order: 3,
        }
    }
    ExtraWorkManagement() {
        //var budge = store.getters.ExtraWorkBudgeCount;
        ////console.log(budge);
        return {
            id: "nav-extra-work-management",
            title: "nav-extra-work-management",
            icon: "",
            to: "admin-extra-work-management",
            subItems: [],
            //budge: budge,
            order: 4,
        }
    }
    
}